export default "__VITE_ASSET__C_c9HVUO__"